import { render, staticRenderFns } from "./CompleteInvite.vue?vue&type=template&id=52d2f97e&scoped=true&"
import script from "./CompleteInvite.js?vue&type=script&lang=js&"
export * from "./CompleteInvite.js?vue&type=script&lang=js&"
import style0 from "./CompleteInvite.vue?vue&type=style&index=0&id=52d2f97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2f97e",
  null
  
)

export default component.exports